type CallbackFunction = () => void;

export const isItDev = () => {
  if (typeof window !== "undefined") {
    return !window.location.href.includes("app.morepleaze.com");
  }

  return false;
};
